define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/def/AddPath",
	"csi/def/Relationship",
	"csi/form/Widget",
	"csi/locale",
	"csi/store/_base",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,_,AddPath,Relationship,Widget,locale,csiStore,Names,xml,Query) {
	var FIELD_FROM = "FromColor";
	var FIELD_TO = "ToColors";

	return declare(Widget, {
		/**
		 * @override
		 * Populate the store correspondingly
		 */
		getFieldStore: function(field, value) {
			var store = {};
			var bomRev = this.getViewNode();
			var cache = this.getFormData().getCache();
			var fromColors = cache.getNodes(bomRev.BOMProductColors);

			if (field.m_name == FIELD_TO) {
				var fromColorUrl = this.getFieldValue(FIELD_FROM);

				var r = lang.mixin(new Relationship(), {
					m_url: this.getViewURL(),
					m_addPaths: [lang.mixin(new AddPath(), {
						m_path: "Child:__Parent__/Child:__Parent__/Child:ProductColors"
					})],
					m_query: new Query()
						.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, fromColorUrl)
						.Attr("Active", xml.OP_EQUALS, true)
				});

				fromColors = _.filter(fromColors, function(color){
					return color.$URL != fromColorUrl;
				});

				var storeOptions = {
					priorityStore: Names.createFromNodes(fromColors, {bSort: false})
				};

				csiStore.namesOptionsByRelationship(this.getContext(), r, storeOptions);
				store = new Names(storeOptions);
			} else {
				store = Names.createFromNodes(fromColors, {bSort: false});
			}

			return store;
		},

		onValidateColorFields: function(formView, field, value, params) {
			var from = this.defView.getFieldValue(FIELD_FROM);
			var to = this.defView.getFieldValue(FIELD_TO);
			if (!xml.isEmptyURL(from) && !xml.isEmptyURL(to) && from == to) {
				throw new Error(locale.resource("ColorToAndFromError"));
			}
		}
	});
});